<template>
    <v-container>
      <v-row>
        <v-col
          v-for="(reel, index) in reels"
          :key="index"
          cols="12"
          md="6"
          lg="4"
        >
          <v-card class="mx-auto" outlined>
            <v-card-title>{{ reel['Reel Concept'] }}</v-card-title>
            <v-card-subtitle>{{ reel['Video Type'] }}</v-card-subtitle>
  
            <v-card-text>
              <p><strong>Example:</strong></p>
              <p class="text-content">{{ reel.Example }}</p>
  
              <p><strong>Inspiration:</strong>
                <a :href="reel.Inspiration" target="_blank">Inspiration Link</a>
              </p>
              <p><strong>Instagram Audio:</strong>
                <a :href="reel['Instagram Audio']" target="_blank">Instagram Audio</a>
              </p>
              <p><strong>TikTok Audio:</strong>
                <a :href="reel['Tik Tok Audio']" target="_blank">TikTok Audio</a>
              </p>
              <p><strong>Caption:</strong></p>
              <p class="text-content">{{ reel.Caption }}</p>
            </v-card-text>
  
            <v-card-actions>
              <v-btn icon @click="copyText(reel.Inspiration)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import reelsData from '@/assets/steal-the-reel-current.json'; // Adjust path as needed
  
  export default {
    data() {
      return {
        reels: reelsData,
        expanded: {}, // Track which cards are expanded for 'Example'
        expandedCaption: {}, // Track which cards are expanded for 'Caption'
      };
    },
    methods: {
      copyText(text) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast('Copied to clipboard!');
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    transition: all 0.3s ease;
    max-width: 100%;
    margin-bottom: 24px;
  }
  
  .v-card-title {
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  .v-card-text {
    white-space: normal;
  }
  
  .text-content {
    max-height: 80px;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Show 3 lines by default */
    -webkit-box-orient: vertical;
  }
  
  .v-btn {
    margin-top: 8px;
  }
  
  .copy-icon {
    cursor: pointer;
  }
  
  .v-card-actions {
    justify-content: flex-end;
  }
  </style>
  